module.exports = __webpack_public_path__ + "assets/img/7.9b0a56e0.png";